import type { AdClickTrackingHandler } from "./ad-click-tracking-handler";

export class AdClickTrackingListener {
    private readonly handler: AdClickTrackingHandler;

    private readonly onDocumentClickBound: (event: Event) => void;

    public constructor(handler: AdClickTrackingHandler) {
        this.handler = handler;
        this.onDocumentClickBound = this.onDocumentClick.bind(this);
    }

    public register(): void {
        document.addEventListener("click", this.onDocumentClickBound);
    }

    private onDocumentClick(event: Event): void {
        if (!(event instanceof MouseEvent)) {
            return;
        }

        this.handler.handleDocumentClick(event);
    }
}
